import { EditorState, convertToRaw, ContentState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

function convertToEditor(text) {
  return EditorState.createWithContent(
    ContentState.createFromBlockArray(htmlToDraft(text).contentBlocks)
  );
}

function convertToString(text) {
  return draftToHtml(convertToRaw(text.getCurrentContent())).trim();
}

function emptyTextEditor() {
  return EditorState.createEmpty();
}

export { convertToEditor, convertToString, emptyTextEditor };
